import { Flex, Text } from "@chakra-ui/react";
import { VerticalSquiggleSmallIcon } from "../../../../components/icons/VerticalSquiggleSmallIcon";

interface SectionHeaderProps {
  title: string;
  viewAllLabel?: string;
  onViewAll?: () => void;
}

export function SectionHeader({
  title,
  viewAllLabel,
  onViewAll,
}: SectionHeaderProps) {
  return (
    <Flex align="center" justify="space-between" mb={3}>
      <Flex align="center" gap="8px">
        <VerticalSquiggleSmallIcon color="blaze.blaze" height="16px" flexShrink={0} />
        <Text
          fontSize="14px"
          fontWeight="700"
          color="white"
          fontFamily="Roboto"
          lineHeight="20px"
        >
          {title}
        </Text>
      </Flex>
      {viewAllLabel && onViewAll && (
        <Flex align="center" gap={1} cursor="pointer" onClick={onViewAll} flexShrink={0}>
          <Text
            fontSize="12px"
            fontWeight="400"
            color="white"
            _hover={{ textDecoration: "underline" }}
          >
            {viewAllLabel}
          </Text>
        </Flex>
      )}
    </Flex>
  );
}
